import React, { useState,useEffect,useRef,useContext } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { InpDataList, CardPerso } from '@gull'
import axios from 'axios'
import swal from "sweetalert2";
import LineCustomMadeItem from './LineCustomMadeItem';
import LineItemFromBase from './LineItemFromBase'
import { IsAuthContext } from 'app/App';

const useLoadInit = () => {
    const t = useTranslate();
    const [loading,setLoading]=useState(true)
    const [customMadeArticles,setCustomMadeArticles]=useState([])

    const [allCustomMadeItem,setAllCustomMadeItem]=useState([]) 

    const [calculValue,setCalculValue]=useState({
        operande:'',
        type:'',
        value:'',
    }) 

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/formule/get_last"
            ).then((response) => {
                if(response.data.formule!=null){
                    setCalculValue({
                        operande:response.data.formule.etape_calcul[0].operande,
                        type:response.data.formule.etape_calcul[0].type,
                        value:response.data.formule.etape_calcul[0].value,
                    })
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
        })()
    }, [])

    useEffect(function () {
        (async function() {
            const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/article/list/100/1",{
                on_demand:true
            }).then((response) => {
                setCustomMadeArticles(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
            setLoading(false)
        })()
    }, [])

    useEffect(function () {
        let dataItemList = [{type:'customItem'}]
        setAllCustomMadeItem(dataItemList)
    }, [])

    return [loading,customMadeArticles,calculValue,allCustomMadeItem,setAllCustomMadeItem]
}

const CustomMadeItemModal = (props) =>{
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [loading,customMadeArticles,calculValue,allCustomMadeItem,setAllCustomMadeItem]=useLoadInit()

    const inputRef = useRef('')
    const listRef = useRef('')
    const [datas,setDatas] = useState(customMadeArticles)
    const [valueInput,setValueInput]=useState('') 
    const [validButton,setValidButton]=useState(false) 

    const idsLocalStorage=localStorage.getItem("pos").split(',')

    let devise = authParam.company.devise;
    let digit = (authParam.company.devise === "XPF") ? 0 : 2;

    const [refCustomMadeItem,setRefCustomMadeItem]=useState({}) 
    
    const [total,setTotal]=useState(0) 

    useEffect(function () {
        let calculTotal = 0
        allCustomMadeItem.map(value=>{
            if(value.hasOwnProperty('price') && value.price!='' && value.hasOwnProperty('qte')){
                calculTotal+= +value.price*value.qte
            }
            else if(value.hasOwnProperty('price') && value.price!=''){
                calculTotal+= +value.price
            }
        })
        setTotal(calculTotal)
    }, [allCustomMadeItem])
    
    const addNewCustomMadeItem = (name) =>{
        setAllCustomMadeItem([...allCustomMadeItem,{type:name}])
    }

    const handleClickFilter = (id,label,nameInput,reference,quota) => {
        setValueInput(label)

        setRefCustomMadeItem({id:id,name:label,reference:reference})

        listRef.current.classList.add("d-none")
    }

    const handleSearch = (e,declenchement) => {
        setValueInput(e.target.value);

        if(e.target.value!=''){
            let ajour = datas.filter((value)=>value.name.toLowerCase().includes(e.target.value.toLowerCase()))
            setDatas(ajour)
        }else{
            setDatas(customMadeArticles)
        }
    }

    const handleFocus = () => {
        setValueInput('')
        setDatas(customMadeArticles)
        listRef.current.classList.remove("d-none");
    }

    const handleBlur = () => {
        if(Object.keys(refCustomMadeItem).length!=0){
            setValueInput(refCustomMadeItem.name)
        }else{
            setValueInput('')
        }

        listRef.current.classList.add("d-none")
    }

    const submitCustomMadeItem = async () =>{

        let data = {}

        if(props.cookies.current_ticket){
            data['id']=props.cookies.current_ticket

        }else{
            if(props.cashierId){
                data['rh_id']=props.cashierId
            }
            if(props.clientId){
                data['client_id']=props.clientId
            }
        }

        let articlesData = {
            [refCustomMadeItem.id]:[]
        }

        allCustomMadeItem.map(article=>{
            if(article.type=='itemBase'){
                articlesData[article.id]={
                    price: article.price,
                    description: '',
                    quantity: article.qte,
                }
            }else if(article.type=='customItem'){
                articlesData[refCustomMadeItem.id].push({
                    base_price: article.base_price,
                    price: article.price,
                    description: article.name,
                    // quantity: article.qte,
                })
            }
        })

        data['articles']=articlesData

        let currentTicketCookie

        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ticket/construction_on_demand/"+props.posid+"/"+idsLocalStorage[1]+"/"+idsLocalStorage[0], data
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                //Vérification si L'article est en stock négatif
                if(!Array.isArray(response.data.negative_stock)){
                    //On vérifie si negative_stock est un objet car si il n'y pas d'article en stock négatif, negative_stock est un []
                    let arrArticle = []
                    props.currentTicket && Object.keys(props.currentTicket).length!=0 && props.currentTicket.ticket_detail.map(value=>{
                        arrArticle.push(value.article_id)
                    })

                    Object.keys(response.data.negative_stock).map(idArticle=>{
                        if(!arrArticle.includes(idArticle)) swal.fire(t('stockNegativeAlertMsg'), "", "warning");
                    })
                }
                
                props.setCurrentTicket(response.data.data)
                currentTicketCookie=response.data.data.id
                if(!props.cookies.current_ticket){
                    props.setCookie("current_ticket",currentTicketCookie,{ path: "/", expires: props.expire_date }) 
                }
                
                //Comme un article sur mesure peut contenir plusieurs articles, tel que des articles de la base, on affiche que sur un afficheur de type second_screen_display
                if(props.peripheriqueParam && props.peripheriqueParam.afficheur && props.peripheriqueParam.afficheur.model=='second_screen_display'){
                    // affiche et envoyé en param 'reason' pour afficher le contenu du ticket sur l'écran secondaire, si on envoie 'clear' il néttoiera l'ensemble de l'afficheir
                    props.affichageClient(response.data.data,false,false,'add',false,false,props.peripheriqueParam)
                }
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setValidButton(false)
        setRefCustomMadeItem({}) 
        setAllCustomMadeItem([])
        props.closeModal()
    }
    
    const submitMiddleWare = () =>{
        setValidButton(true)
        let articleOk = []
        let articleErreur = []

        allCustomMadeItem.map(article=>{
            if(article.type=='itemBase'){
                if(article.hasOwnProperty('name') && article.hasOwnProperty('price') && article.hasOwnProperty('qte') && article.name!='' && article.price!='' && article.qte!=''){
                    articleOk.push(article)
                }else{
                    articleErreur.push(article)
                }
            }else if(article.type=='customItem'){
                if(article.hasOwnProperty('name') && article.hasOwnProperty('base_price') && article.hasOwnProperty('price') && article.name!='' && article.base_price!='' && article.price!=''){
                    articleOk.push(article)
                }else{
                    articleErreur.push(article)
                }
            }
        })

        if(articleErreur.length!=0){
            //Si il y a des champs qui n'ont pas été reneignés
            swal.fire(t('allFieldsRequired'), "", "error");
            setValidButton(false)
        }else{
            //Si tous les champs ont été renseignés 
            submitCustomMadeItem()
        }
    }

    return (
        <div className='row d-flex justify-content-center position-relative'>
            {(loading) ? 
                <span className='d-flex justify-content-center'><div className="spinner-border spinner-border-sm mt-2"></div></span>
            :
                <>
                    <div className='col-10 form-group'>
                        <label>{t('referenceItem')}</label>
                        <InpDataList
                            placeholder="-- Select --"
                            value={valueInput}
                            onClick={handleClickFilter}
                            onChange={handleSearch}
                            datas={datas}
                            declenchement={0}
                            listRef={listRef}
                            inputRef={inputRef}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            inputName="articleSearch"
                        />
                    </div>

                    <div className='col-11 mb-2'>
                        <hr />
                    </div>

                    {(Object.keys(refCustomMadeItem).length!=0) ?
                        <div className='col-11 form-group'>
                            <CardPerso header={<>
                                <label className='d-flex justify-content-between align-items-end' style={{width:'100%'}}>
                                    <span style={{color:'white'}}>{t('complementaryItem')}</span>
                                    <span>
                                        <button className='btn btn-sm btn-primary' onClick={()=>addNewCustomMadeItem('itemBase')}>{t('addItemFromBase')}</button>&nbsp;&nbsp;
                                        <button className='btn btn-sm btn-info' onClick={()=>addNewCustomMadeItem('customItem')}>{t('addSupplierItem')}</button>
                                    </span>
                                </label>
                            </>
                            }>
                                {(allCustomMadeItem.length!=0)?
                                    allCustomMadeItem.map((customMadeItem,ind)=>{
                                        if(customMadeItem.type=='itemBase'){
                                            return(
                                                <LineItemFromBase
                                                    key={ind}
                                                    indexToEdit={ind}
                                                    customMadeItem={customMadeItem}
                                                    allCustomMadeItem={allCustomMadeItem}
                                                    setAllCustomMadeItem={setAllCustomMadeItem}
                                                />
                                            )
                                        }else{
                                            return(
                                                <LineCustomMadeItem
                                                    key={ind}
                                                    indexToEdit={ind}
                                                    customMadeItem={customMadeItem}
                                                    allCustomMadeItem={allCustomMadeItem}
                                                    setAllCustomMadeItem={setAllCustomMadeItem}
                                                    calculValue={calculValue}
                                                    deletable={(ind==0)?false:true}
                                                />
                                            )
                                        }
                                    })
                                :
                                    <div className='text-center fw-bold text-muted'>{t('noItems')}</div>
                                }
                                <div className='d-flex justify-content-between mt-4'>
                                    <div>
                                    {(allCustomMadeItem.length!=0) && 
                                        <button className='btn btn-primary' onClick={()=>submitMiddleWare()}>
                                            {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                                        </button>
                                    }
                                    </div>
                                    <div className='fw-bold fs-5 d-flex justify-content-end align-items-end'>
                                        <span>Total :</span>&nbsp;&nbsp;
                                        <span>{total+devise}</span>
                                    </div>
                                </div>
                            </CardPerso>
                        </div>
                    :
                        false
                    }
                    
                </>
            }
        </div>
    )
};

export default CustomMadeItemModal;